import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from '@/app/App';
import { initPlatform } from '@/platform';
import './index.css';

// Swap in native adapters before first paint where applicable (spec §2.3).
void initPlatform();

/**
 * The standalone preview build is a single HTML file served without a
 * server-side SPA fallback, so it uses hash routing. The real web and native
 * builds use ordinary paths.
 */
const Router = import.meta.env.VITE_HASH_ROUTER === '1' ? HashRouter : BrowserRouter;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
